import RelationContentList from 'components/RelationContentList'
import useTodo from 'hooks/useTodo'
import { Relation } from 'types/app'
import { DASHBOARD_SECTIONS } from 'types/enums'

interface Props {
	relations: Relation[]
}

const Rejected = ({ relations }: Props): JSX.Element => {
	useTodo(
		relations?.length,
		3,
		'APP_REJECTED_LABEL',
		DASHBOARD_SECTIONS.CASTING,
	)

	return <RelationContentList relations={relations} showUser={false} />
}

export default Rejected
